import { ReactNode } from 'react'
import '../../font-preview/font-previews.css'

const FontPreviews = ({ children }: { children?: ReactNode }) => <>{children}</>

export default FontPreviews
